import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import { ListContainer } from './styled';

interface ValuationItemProps {
  template: any;
  onClick: (templateId: any) => void;
  onDelete: (templateId: any, templateName: any) => void;
  [key: string]: any;
}

function ValuationItem({
  onDelete,
  onClick,
  template,
  ...props
}: ValuationItemProps) {
  return (
    <ListContainer {...props}>
      <Text
        size="14px"
        height="30px"
        as="a"
        style={{ flex: 1 }}
        onClick={() => onClick(template.id)}
      >
        {template.name}
      </Text>
      <IconWrapper padding="0 5px">
        <Iconmoon
          className="icon-widget_close"
          color={color.sunsetOrange}
          hoverColor={color.sunsetOrange}
          size="14px"
          weight="bold"
          onClick={() => onDelete(template.id, template.name)}
        />
      </IconWrapper>
    </ListContainer>
  );
}

export default ValuationItem;
